// Prefixes the browser tab title with the environment on non-prod builds, so
// local/dev tabs are unmistakable when several environments are open at once
// (live / lovable / dev / local). Prod and the Lovable preview get no prefix.
//
// Detection is hostname-based: there is no clean environment enum exposed to the
// client (env.API_ENV is an API URL segment, not an env name), and the codebase
// already keys off window.location.hostname elsewhere. Prod uses a custom domain
// (not *.run.app, no "dev"), so it won't match. Adjust the heuristics here if the
// dev/prod hostnames change.

export function resolveEnvPrefix() {
  const host = (window.location.hostname || "").toLowerCase();

  if (host.includes("localhost") || host === "127.0.0.1" || host.endsWith(".local")) {
    return "{{LOCAL}} ";
  }
  if (host.includes("dev") || host.endsWith(".run.app")) {
    return "{{DEV}} ";
  }
  return ""; // prod / live / lovable — no prefix
}

const KNOWN_PREFIX = /^\{\{(LOCAL|DEV)\}\}\s*/;

/**
 * Apply an env prefix to document.title on non-prod environments and keep it
 * applied when react-helmet (or anything else) rewrites the title.
 */
export function applyEnvTitlePrefix() {
  const prefix = resolveEnvPrefix();
  if (!prefix) return; // prod/live/lovable: leave the title untouched

  const titleEl =
    document.querySelector("title") ||
    document.head.appendChild(document.createElement("title"));

  const apply = () => {
    const current = document.title;
    const base = current.replace(KNOWN_PREFIX, "");
    const next = prefix + base;
    if (current !== next) document.title = next; // guarded → no observer loop
  };

  apply();
  // react-helmet updates the title after mount/route changes; re-apply each time.
  new MutationObserver(apply).observe(titleEl, {
    childList: true,
    characterData: true,
    subtree: true,
  });
}
